import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"
import AppDetailPage from "@/components/layout/AppDetailPage.vue"
import UserAvatarGroup from "@/components/widgets/common/UserAvatarGroup.vue"
import Tab from "@/components/widgets/Tabs/Tab.vue"
import Tabs from "@/components/widgets/Tabs/Tabs.vue"
import Home from "@/modules/Missions/components/Details/Overview/Overview.vue"
import Billing from "@/modules/Missions/components/Details/Billing/ClientBilling.vue"
import Documents from "@/modules/Missions/components/Details/Documents/Documents.vue"
import { useQuery } from "@vue/apollo-composable"
import {
  ClientMissionLifecyclesDetailsQuery,
  ClientMissionLifecyclesDetailsQueryQuery,
  ClientMissionLifecyclesDetailsQueryQueryVariables,
  ClientMissionLifecycleFragmentFragment,
} from "@/gql"
import useRouter from "@/router/useRouter"
import MissionToolbar from "@/modules/Missions/components/Details/MissionToolbar/MissionToolbar.vue"
import { useUrl } from "@/hooks/useUrl"
import { PageState } from "@/constants"
import { usePageState } from "@/hooks/usePageState"
import PageStateError from "@/components/widgets/common/PageStateError.vue"
import { provideMissionLifecycleContext } from "../../hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDetailPage',
  setup(__props) {

const { router, routes } = useRouter()

const { loading, refetch, onError, onResult } = useQuery<
  ClientMissionLifecyclesDetailsQueryQuery,
  ClientMissionLifecyclesDetailsQueryQueryVariables
>(ClientMissionLifecyclesDetailsQuery, {
  filter: {
    missionId: router.currentRoute.params.id,
  },
  per: 1,
})

const refetchQueries = computed(() => {
  return [
    {
      query: ClientMissionLifecyclesDetailsQuery,
      variables: {
        filter: {
          missionId: router.currentRoute.params.id,
        },
        per: 1,
      },
    },
  ]
})

const mission = ref<ClientMissionLifecycleFragmentFragment | null>(null)

const collaborators = computed(() => {
  return mission.value ? mission.value.collaborators : []
})

provideMissionLifecycleContext({ mission: mission, refetch })

const pageState = ref(PageState.Idle)

const { handlePageErrorState } = usePageState(pageState)

onError((error) => {
  handlePageErrorState(error)
})

onResult((result) => {
  if (result?.data?.clientMissions?.data.length === 0) {
    pageState.value = PageState.Empty
  }

  if (result.data?.clientMissions?.data.length) {
    mission.value = result.data?.clientMissions?.data[0]
  }
})

const tabs = [
  {
    label: "Home",
    key: "home",
  },
  {
    label: "Billing",
    key: "billing",
  },
  {
    label: "Documents",
    key: "documents",
  },
]

const projectLink = computed(() => {
  return useUrl(routes.ClientProjectDetails, { id: mission.value?.id.toString() }).href
})

return { __sfc: true,router, routes, loading, refetch, onError, onResult, refetchQueries, mission, collaborators, pageState, handlePageErrorState, tabs, projectLink, AppDetailPage, UserAvatarGroup, Tab, Tabs, Home, Billing, Documents, MissionToolbar, PageState, PageStateError }
}

})